import MaterialDrawer, { DrawerProps } from '@mui/material/Drawer';

export function Drawer(props: DrawerProps) {
    return <MaterialDrawer data-testid={'Drawer-container'} {...props} />;
}

export default Drawer;
